export const MORE_INFORMATION = ["guarantee", "instructions_for_use", "storage_information"];
export const VARIANT_VALUES = "variant_value";
export const VARIANT_DESCRIPTION = "variant_description";
export const COLOR = "color";
export const WIDTH = "width";
export const HEIGHT = "height";
export const LENGTH = "length";
export const MEASUREMENT = "measurement";
export const WEIGHT = "weight";
export const VOLUME = "volume";
export const MATERIAL = "material";
export const PACKAGE_QUANTITY = "package_quantity";
export const COMPARISON_PRICE_UNIT = "comparison_price_unit";
export const STOCK_INFO_EXCLUDED_STORES = [];
export const EXCLUDED_STORES = [];
